import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/recharge/out/homepage',
    component: () => import('@/pages/recharge/out/homepage'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      {
        path: 'recharge',
        component: () => import('@/pages/recharge/out/recharge'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      },
      {
        path: 'record',
        component: () => import('@/pages/recharge/record'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [Constants.CONFIG_TYPE_QUERY]);
        }
      }
    ]
  },
  {
    path: '/recharge/in/homepage',
    component: () => import('@/pages/recharge/in/homepage'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      {
        path: 'recharge',
        component: () => import('@/pages/recharge/in/recharge'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      },
      {
        path: 'record',
        component: () => import('@/pages/recharge/record'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [Constants.CONFIG_TYPE_QUERY]);
        }
      }
    ]
  }
];
